import { Component } from "@angular/core";

@Component({
  selector: "header-combined-part",
  template: '<ng-content></ng-content>',
})
export class HeaderCombinedPartComponent {
}
